import Cookies from 'js-cookie';
import React, { createContext, useState, useContext, ReactNode } from 'react';


interface AuthContextType {
  user: string | null;
  login: (userData: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<any>(null);

  const login = (userData: string) => {
    setUser(userData)
    Cookies.set('user', userData)
  };

  const logout = () => {
    setUser(null);
    Cookies.remove('user')
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
